import { useEffect } from "react";

const usePreventUnload = (message = "Are you sure you want to leave?") => {
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = message; // Standard for most browsers
      return message;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [message]);
};

export default usePreventUnload;
